<template>
    <div class="dynamic-table table-responsive p-sm-3">
        <!-- <form> -->

            <template v-if="G.lang_list.length > 1">
                <Tabs :scrollable="true" v-if="data.table_columns_forlang !== undefined && data.table_columns_forlang.length" :value="0">
                    <TabList>
                        <Tab v-for="(li, lind) in G.lang_list" :key="li.value" :value="lind">
                            <span class="me-2">{{ li.flag }}</span>
                            <span>{{ li.label }}</span>
                        </Tab>
                    </TabList>
                    <TabPanels class="bg-light">
                        <TabPanel v-for="(li, lind) in G.lang_list" :key="li.value" :value="lind">
                            <!-- <template #header>
                                <span class="me-2">{{ li.flag }}</span>
                                <span>{{ li.label }}</span>
                            </template> -->

                            <template v-for="(item, index) in data.table_columns_forlang" :key="index">

                                <div class="mb-1 p-1" v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data, PO) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">

                                    <div class="mb-1 fw-bold" v-if="G.userHavePermission(data.data.permission_method) || (item.field_type != 'image' && item.field_type != 'file')" v-html="item.title + ' (' + li.label + ')'"></div>

                                    <div class="mb-1" v-if="G.userHavePermission(data.data.permission_method)">
                                        <InputText
                                            v-if="item.field_type == 'text'"
                                            v-model="PO['newdata'][item.name][li.value]"
                                            type="text"
                                            :maxlength="item.max !== undefined ? item.max : undefined"
                                            :class="item.class + (item.required && (PO['newdata'][item.name][li.value] === undefined || PO['newdata'][item.name][li.value] === '' || PO['newdata'][item.name][li.value] === null) ? ' required' : '')"
                                            :placeholder="item.placeholder || item.title || ''"
                                            :[item.attr]="item.attrValue"
                                        />
                                        <TextEditor v-else-if="item.field_type == 'editor-simple'"
                                            v-model="PO['newdata'][item.name][li.value]"
                                            :class="item.class + (item.required && (PO['newdata'][item.name][li.value] === undefined || PO['newdata'][item.name][li.value] === '' || PO['newdata'][item.name][li.value] === null) ? ' required' : '')"
                                            :placeholder="item.placeholder || item.title || ''"
                                            :[item.attr]="item.attrValue"
                                            :editorStyle="`height: ${item.height || 200}px;`"
                                        />
                                        <TextEditor2 v-else-if="item.field_type == 'editor'"
                                            v-model="PO['newdata'][item.name][li.value]"
                                            :class="item.class + (item.required && (PO['newdata'][item.name][li.value] === undefined || PO['newdata'][item.name][li.value] === '' || PO['newdata'][item.name][li.value] === null) ? ' required' : '')"
                                            :placeholder="item.placeholder || item.title || ''"
                                            :[item.attr]="item.attrValue"
                                            :editorStyle="`height: ${item.height || 350}px;`"
                                        />
                                            <!-- :pt="{
                                                root: {style: 'padding: 0px;'},
                                                content: {style: 'height: 250px;'}
                                            }" -->
                                        <Textarea v-else-if="item.field_type == 'textarea'"
                                            v-model="PO['newdata'][item.name][li.value]"
                                            :autoResize="false"
                                            :class="item.class + (item.required && (PO['newdata'][item.name][li.value] === undefined || PO['newdata'][item.name][li.value] === '' || PO['newdata'][item.name][li.value] === null) ? ' required' : '')"
                                            :rows="item.text_rows !== undefined ? item.text_rows : 3"
                                            :cols="item.text_cols !== undefined ? item.text_cols : 20"
                                            :placeholder="item.placeholder || item.title || ''"
                                            :[item.attr]="item.attrValue"
                                            class="form-control"
                                        />
                                    </div>
                                    <span class="mb-2" v-else v-html="typeof item.value === 'function' ? item.value(data.data.translate.filter(b => b.lang_id == li.value)) : data.data[item.value]"></span>

                                </div>

                            </template>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
            </template>

            <!-- <div class="d-flex justify-content-center mb-4" v-if="data.table_columns_forlang !== undefined && data.table_columns_forlang.length">
                <hr />
            </div> -->

            <div class="table border-0">
                <!-- <div class="row">
                        <div class="col-12 col-sm-3 fw-bold"></div>
                        <div class="col-12 col-sm-9 fw-bold"></div>
                </div> -->
                <div v-if="data.table_columns">
                    <template v-if="G.lang_list.length == 1 && data.table_columns_forlang && data.table_columns_forlang.length" v-for="(item, index) in data.table_columns_forlang" :key="index">

                        <div class="row" v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data, PO) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">

                            <div class="col-12 col-sm-3 fw-bold1 align-middle bg-light" v-if="G.userHavePermission(data.data.permission_method) || (item.field_type != 'image' && item.field_type != 'file')" v-html="item.title"></div>

                            <div v-if="G.userHavePermission(data.data.permission_method)" class="col-12 col-sm-9 align-middle bg-light">
                                <InputText
                                    v-if="item.field_type == 'text'"
                                    v-model="PO['newdata'][item.name][G.lang_list[0].value]"
                                    type="text"
                                    :maxlength="item.max !== undefined ? item.max : undefined"
                                    :class="item.class + (item.required && (PO['newdata'][item.name][G.lang_list[0].value] === undefined || PO['newdata'][item.name][G.lang_list[0].value] === '' || PO['newdata'][item.name][G.lang_list[0].value] === null) ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                />
                                <TextEditor v-else-if="item.field_type == 'editor-simple'"
                                    v-model="PO['newdata'][item.name][G.lang_list[0].value]"
                                    :class="item.class + (item.required && (PO['newdata'][item.name][G.lang_list[0].value] === undefined || PO['newdata'][item.name][G.lang_list[0].value] === '' || PO['newdata'][item.name][G.lang_list[0].value] === null) ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    :editorStyle="`height: ${item.height || 200}px;`"
                                />
                                <TextEditor2 v-else-if="item.field_type == 'editor'"
                                    v-model="PO['newdata'][item.name][G.lang_list[0].value]"
                                    :class="item.class + (item.required && (PO['newdata'][item.name][G.lang_list[0].value] === undefined || PO['newdata'][item.name][G.lang_list[0].value] === '' || PO['newdata'][item.name][G.lang_list[0].value] === null) ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    :editorStyle="`height: ${item.height || 350}px;`"
                                />
                                    <!-- :pt="{
                                        root: {style: 'padding: 0px;'},
                                        content: {style: 'height: 250px;'}
                                    }" -->
                                <Textarea v-else-if="item.field_type == 'textarea'"
                                    v-model="PO['newdata'][item.name][G.lang_list[0].value]"
                                    :autoResize="false"
                                    :class="item.class + (item.required && (PO['newdata'][item.name][G.lang_list[0].value] === undefined || PO['newdata'][item.name][G.lang_list[0].value] === '' || PO['newdata'][item.name][G.lang_list[0].value] === null) ? ' required' : '')"
                                    :rows="item.text_rows !== undefined ? item.text_rows : 3"
                                    :cols="item.text_cols !== undefined ? item.text_cols : 20"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    class="form-control"
                                />
                            </div>
                            <div class="col-12 col-sm-9" v-else-if="item.field_type != 'image' && item.field_type != 'file'">
                                <Image
                                    v-if="(item.name == 'preview_image' && item.field_type == 'label') || item.field_type == 'preview_image'"
                                    :src="PO['newdata'][item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="false"
                                />
                                <span v-else v-html="typeof item.value === 'function' ? item.value(data.data, data) : data.data[item.value]"></span>
                            </div>

                        </div>

                    </template>


                    <template v-for="(item, index) in data.table_columns" :key="index">

                        <div class="row m-0 d-flex align-items-center" v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data, PO) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">
                            <div
                                v-if="G.userHavePermission(data.data.permission_method) || (item.field_type != 'image' && item.field_type != 'file')"
                                class="col-12 col-sm-3 fw-semibold"
                                v-html="item.title"></div>

                            <div v-if="G.userHavePermission(data.data.permission_method)" class="col-12 col-sm-9 align-middle">

                                <Image
                                    v-if="(item.name == 'preview_image' && item.field_type == 'label') || item.field_type == 'preview_image'"
                                    :src="PO['newdata'][item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="true"
                                />

                                <div v-else-if="item.field_type == 'image'" class="d-flex flex-sm-row1 flex-column text-nowrap align-items-start">
                                    <!-- <FileUpload
                                        v-model="PO['newdata'][item.name]"
                                        :mode="item.fileSelectMode"
                                        name="images[]"
                                        :customUpload="true"
                                        @select="onFileChanged($event, item.name)"
                                        accept="image/*"
                                        :multiple="item.fileSelectMode == 'basic' ? false : (item.fileMultiple || false)"
                                        :fileLimit="item.fileSelectMode == 'basic' ? 1 : (item.fileLimit || 1)"
                                        :maxFileSize="item.fileMaxSize"
                                        :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                        :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        :uploadLabel="item.uploadLabel || TR.upload"
                                        :chooseLabel="item.chooseLabel || TR.select_file"
                                    >
                                        <template #empty>
                                            <p>{{TR.drag_file}}</p>
                                        </template>
                                    </FileUpload> -->
                                    <InputFile
                                        v-model="PO['newdata'][item.name]"
                                        :multiple="item.fileSelectMode == 'basic' ? false : (item.fileMultiple || false)"
                                        accept="image/*"
                                        :placeholder="TR.select_file" :sizeErrorLabel="TR.file_size_limit_error"
                                        @select="onFileChanged($event, item.name);"
                                    ></InputFile>

                                    <!-- <span class="mx-2 my-2">{{TR.or}}</span>
                                    <InputText
                                        v-model="PO['newdata'][item.name]"
                                        type="text"
                                        class=""
                                        @change="onImageChanged($event, item.name)"
                                        :placeholder="TR.link"
                                    /> -->
                                </div>

                                <div v-else-if="item.field_type == 'file'" class="d-flex flex-sm-row1 flex-column text-nowrap align-items-start1 text-start">

                                    <InputFile v-model="PO['newdata'][item.name]" :accept="item.accept !== undefined ? item.accept : ''" :multiple="item.fileSelectMode == 'basic' ? false : (item.fileMultiple || false)" :placeholder="TR.select_file" :sizeErrorLabel="TR.msgInvalidFileSize" @select="onFileChanged($event, item.name);">
                                    </InputFile>

                                    <!-- <FileUpload
                                        v-model="PO['newdata'][item.name]"
                                        :mode="item.fileSelectMode"
                                        name="images[]"
                                        :customUpload="true"
                                        @select="onFileChanged($event, item.name);"
                                        :accept="item.accept !== undefined ? item.accept : ''"
                                        :multiple="item.fileSelectMode == 'basic' ? false : (item.fileMultiple || false)"
                                        :fileLimit="item.fileSelectMode == 'basic' ? 1 : (item.fileLimit || 1)"
                                        :maxFileSize="item.fileMaxSize"
                                        :invalidFileSizeMessage="TR.invalidFileSizeMessage"
                                        :invalidFileLimitMessage="TR.invalidFileLimitMessage"
                                        :uploadLabel="item.uploadLabel || TR.upload"
                                        :chooseLabel="item.chooseLabel || TR.select_file"
                                    >
                                        <template v-if="item.fileSelectMode == 'advanced'" #header="{ chooseCallback, uploadCallback, clearCallback, files }">
                                            <div class="d-flex flex-wrap justify-content-between align-items-center flex-1 gap-4">
                                                <div class="flex gap-2">
                                                    <Button @click="chooseCallback()" icon="fas fa-images" :disabled="totalSize <= G.uploadedFileSize ? false : true" rounded outlined severity="secondary"></Button>
                                                    <Button @click="clearFiles(clearCallback)" icon="fas fa-times" rounded outlined severity="danger" :disabled="!files || files.length === 0"></Button>
                                                </div>
                                            </div>
                                            <div>{{ G.formatSize(totalSize) }} &nbsp;&nbsp; ( Max: {{ G.formatSize(G.uploadedFileSize) }} )</div>
                                        </template>

                                        <template v-if="item.fileSelectMode == 'advanced' && totalSize <= G.uploadedFileSize" #content="{ files, uploadedFiles, removeUploadedFileCallback, removeFileCallback }">
                                            <div v-if="files.length > 0" class="w-1001 d-flex flex-column gap-8">
                                                <div v-for="(file, index) of files" :key="file.name + file.type + file.size" class="p-2 border d-flex flex-row border align-items-center">
                                                    <div>
                                                        <img v-if="file.type.match('^image')" role="presentation" :alt="file.type" :title="file.name" :src="file.objectURL" width="50" height="auto" />
                                                        <div v-else :title="file.name"  class="text-secondary" style="width: 50px; text-align: center; font-size: 2rem !important;" v-html="G.getFileMimeType(file, $event)"></div>
                                                    </div>
                                                    <div class="flex-column ms-3 me-auto">
                                                        <span class="fw-semibold col-2 text-truncate text-wrap overflow-hidden">{{ file.name }}</span>
                                                        <div>{{ G.formatSize(file.size) }}</div>
                                                    </div>
                                                    <button class="btn ms-1" @click="onRemoveTemplatingFile(file, removeFileCallback, index)">
                                                        <div class="fas fa-times text-danger"></div>
                                                    </button>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else-if="totalSize > G.uploadedFileSize" #content>
                                            <div class="d-flex flex-column align-items-center justify-content-center text-danger">
                                                <i class="fas fa-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color" />
                                                <p class="mt-6 mb-0">{{ TR.msgInvalidFileSize.replace('{0}', G.formatSize(G.uploadedFileSize)) }}</p>
                                            </div>
                                        </template>

                                        <template #empty>
                                            <div class="d-flex flex-column align-items-center justify-content-center">
                                                <i class="fas fa-upload !border-2 !rounded-full !p-8 !text-4xl !text-muted-color" />
                                                <p class="mt-6 mb-0">{{ TR.drag_file }}</p>
                                            </div>
                                        </template>
                                    </FileUpload> -->

                                    <template v-if="item.fileSelectMode != 'advanced'">
                                        <span class="mx-2">{{TR.or}}</span>
                                        <InputText
                                            v-model="PO['newdata'][item.name]"
                                            type="text"
                                            class=""
                                            @change="onImageChanged($event, item.name)"
                                            :placeholder="TR.link"
                                        />
                                    </template>
                                </div>

                                <InputText
                                    v-else-if="item.field_type == 'text'"
                                    v-model="PO['newdata'][item.name]"
                                    type="text"
                                    :maxlength="item.max !== undefined ? item.max : undefined"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === '') ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, PO) : null;"
                                    :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false"
                                />

                                <InputText v-else-if="item.field_type == 'password'" v-model="PO['newdata'][item.name]" type="password" :class="item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === '') ? 'required' : ''"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                />

                                <InputNumber v-else-if="item.field_type == 'integer'"
                                    v-model="PO['newdata'][item.name]"
                                    integeronly
                                    mode="decimal"
                                    :step="item.step !== undefined ? item.step : 1"
                                    :showButtons="item.increment === undefined || item.increment == true"
                                    buttonLayout="horizontal"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping !== undefined && item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :suffix="item.suffix !== undefined ? item.suffix : undefined"
                                    :prefix="item.prefix !== undefined ? item.prefix : undefined"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, PO) : null;"
                                >
                                    <template #incrementbuttonicon>
                                        <span class="fas fa-plus" />
                                    </template>
                                    <template #decrementbuttonicon>
                                        <span class="fas fa-minus" />
                                    </template>
                                </InputNumber>

                                <InputNumber v-else-if="item.field_type == 'numeric'"
                                    v-model="PO['newdata'][item.name]"
                                    :step="item.step !== undefined ? item.step : 1"
                                    :showButtons="item.increment === undefined || item.increment == true"
                                    buttonLayout="horizontal"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping !== undefined && item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :suffix="item.suffix !== undefined ? item.suffix : undefined"
                                    :prefix="item.prefix !== undefined ? item.prefix : undefined"
                                    :minFractionDigits="item.minFraction !== undefined ? item.minFraction : 2"
                                    :maxFractionDigits="item.maxFraction !== undefined ? item.maxFraction : 3"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, PO) : null;"
                                >
                                    <template #incrementbuttonicon>
                                        <span class="fas fa-plus" />
                                    </template>
                                    <template #decrementbuttonicon>
                                        <span class="fas fa-minus" />
                                    </template>
                                </InputNumber>

                                <InputNumber v-else-if="item.field_type == 'currency'"
                                    v-model="PO['newdata'][item.name]"
                                    mode="currency"
                                    :step="item.step !== undefined ? item.step : 1"
                                    showButtons
                                    buttonLayout="horizontal"
                                    :currency="store.getCurrency()"
                                    :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :useGrouping="item.grouping !== undefined && item.grouping == true ? true : false"
                                    :min="item.min !== undefined ? item.min : 0"
                                    :max="item.max !== undefined ? item.max : undefined"
                                    :suffix="item.suffix !== undefined ? item.suffix : undefined"
                                    :prefix="item.prefix !== undefined ? item.prefix : undefined"
                                    :minFractionDigits="item.minFraction !== undefined ? item.minFraction : 2"
                                    :maxFractionDigits="item.maxFraction !== undefined ? item.maxFraction : 3"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, PO) : null;"
                                >
                                    <template #incrementbuttonicon>
                                        <span class="fas fa-plus" />
                                    </template>
                                    <template #decrementbuttonicon>
                                        <span class="fas fa-minus" />
                                    </template>
                                </InputNumber>

                                <InputMask v-else-if="item.field_type == 'mask'" v-model="PO['newdata'][item.name]" :mask="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                                    :placeholder="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')" :[item.attr]="item.attrValue" />

                                <!-- <ColorPicker v-else-if="item.field_type == 'color'" v-model="PO['newdata'][item.name]" defaultColor="{'r':128,'g':22,'b':22}" style="background-color: var(--bs-primary-rgb);" format="rgb" :class="item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? 'required' : ''" :placeholder="item.placeholder || item.title || ''" -->

                                <ColorPicker v-else-if="item.field_type == 'color'" v-model="PO['newdata'][item.name]" defaultColor="03446c" format="rgb" :placeholder="item.placeholder || item.title || ''" />

                                <div v-else-if="item.field_type == 'switch'" class="form-check form-switch" :class="item.class">
                                    <input
                                        v-model="PO['newdata'][item.name]"
                                        :id="`${item.name}_switch`"
                                        class="form-check-input cursor-pointer"
                                        :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                        @[item.event]="item.callback !== undefined ? item.callback($event, item, PO) : null"
                                        type="checkbox"
                                        role="switch"
                                        :placeholder="item.placeholder || item.title || ''"
                                    />
                                    <label class="form-check-label cursor-pointer ms-2" :for="`${item.name}_switch`">{{ item.label }}</label>
                                </div>

                                <div v-else-if="item.field_type == 'checkbox'" class="form-check" :class="item.class">
                                    <input
                                        v-model="PO['newdata'][item.name]"
                                        :id="`${item.name}_checkbox`"
                                        class="form-check-input cursor-pointer"
                                        :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                        @[item.event]="item.callback !== undefined ? item.callback($event, item, PO) : null"
                                        type="checkbox"
                                        role="switch"
                                        :placeholder="item.placeholder || item.title || ''"
                                    />
                                    <label class="form-check-label cursor-pointer ms-2" :for="`${item.name}_checkbox`">{{ item.label }}</label>
                                </div>

                                <Textarea v-else-if="item.field_type == 'textarea'"
                                    v-model="PO['newdata'][item.name]"
                                    :autoResize="false"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :rows="item.text_rows !== undefined ? item.text_rows : 3"
                                    :cols="item.text_cols !== undefined ? item.text_cols : 20"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    class="form-control"
                                    @change="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false"
                                ></Textarea>

                                <TextEditor v-else-if="item.field_type == 'editor-simple'"
                                    v-model="PO['newdata'][item.name]"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    :editorStyle="`height: ${item.height || 200}px;`"
                                />
                                <TextEditor2 v-else-if="item.field_type == 'editor'"
                                    v-model="PO['newdata'][item.name]"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :placeholder="item.placeholder || item.title || ''"
                                    :[item.attr]="item.attrValue"
                                    :editorStyle="`height: ${item.height || 350}px;`"
                                />
                                    <!-- :pt="{
                                        root: {style: 'padding: 0px;'},
                                        content: {style: 'height: 250px;'}
                                    }" -->

                                <DatePicker v-else-if="item.field_type == 'date'"
                                    v-model="PO['newdata'][item.name]"
                                    :dateFormat="item.date_format"
                                    :maxDate="item.maxDate || null"
                                    :minDate="item.minDate || null"
                                    :showTime="item.showTime === undefined ? true : item.showTime"
                                    :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                                    :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                                    :hideOnDateTimeSelect="true"
                                    :showButtonBar="true"
                                    :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @update:modelValue="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    showIcon fluid iconDisplay="input"
                                >
                                    <template #inputicon="slotProps">
                                        <i class="far fa-calendar-alt" @click="slotProps.clickCallback" />
                                    </template>
                                </DatePicker>

                                <DatePicker v-else-if="item.field_type == 'time'"
                                    v-model="PO['newdata'][item.name]"
                                    :showTime="item.showTime === undefined ? true : item.showTime"
                                    :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                                    :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                                    :timeOnly="true"
                                    hourFormat="24"
                                    :hideOnDateTimeSelect="true"
                                    :placeholder="item.placeholder || item.title || 'hh:mm:ss'"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @update:modelValue="( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    showIcon fluid iconDisplay="input"
                                >
                                    <template #inputicon="slotProps">
                                        <i class="far fa-clock" @click="slotProps.clickCallback" />
                                    </template>
                                </DatePicker>

                                <Select v-else-if="item.field_type == 'selectbox'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.selectbox_items"
                                    optionValue="label"
                                    optionLabel="label"
                                    :editable="true"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :class="item.class + (item.required && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null) ? ' required' : '')"
                                    :[item.attr]="item.attrValue"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    @input="PO['newdata'][item.name] = selectedItem[item.name]; (item.onInput !== undefined && typeof item.onInput === 'function' ) ? item.onInput($event, item) : null;"
                                />

                                <Select v-else-if="item.field_type == 'dropdown'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.dropdown_items"
                                    optionValue="value"
                                    optionLabel="label"
                                    :placeholder="item.placeholder || TR.select"
                                    :filter="item.dropdown_items.length > 10 ? true : false"
                                    :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :[item.attr]="item.attrValue"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    @input="PO['newdata'][item.name] = selectedItem[item.name]; (item.onInput !== undefined && typeof item.onInput === 'function' ) ? item.onInput($event, item) : null;"
                                >
                                    <template #value="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.value) : item.dropdown_item_class"
                                            v-if="slotProps.value"
                                            v-html="(item.dropdown_items.filter((e) => e.value == slotProps.value)[0]?.icon ?? '') + ' ' + item.dropdown_items.filter((e) => e.value == slotProps.value)[0]?.label"
                                        ></div>
                                        <span v-else>{{slotProps.placeholder}}</span>
                                    </template>
                                    <template #option="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                            v-html="(slotProps.option.icon ?? '') + (slotProps.option.icon ? ' ' : '' ) + slotProps.option.label"
                                        ></div>
                                    </template>
                                    <template v-if="item.dropdown_icon" #dropdownicon>
                                        <i :class="item.dropdown_icon || 'fas fa-list'" />
                                    </template>
                                    <template v-if="item.dropdown_footer !== undefined && typeof item.dropdown_footer === 'function' ? item.dropdown_footer(item, $event) : (item.dropdown_footer !== undefined ? item.dropdown_footer : false)" #footer>
                                        <div class="p-2 d-flex justify-content-between border-top">
                                            <Button v-if="item.dropdown_add_btn !== undefined && typeof item.dropdown_add_btn === 'function' ? item.dropdown_add_btn() : (item.dropdown_add_btn !== undefined ? item.dropdown_add_btn : false)" :label="TR.add" severity="secondary" size="small" icon="fas fa-plus" variant="outlined" @click="item.dropdown_add_btn_callback !== undefined && typeof item.dropdown_add_btn_callback === 'function' ? item.dropdown_add_btn_callback() : null" />
                                        </div>
                                    </template>
                                </Select>

                                <Select v-else-if="item.field_type == 'dropdown_group'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.dropdown_items"
                                    optionValue="value"
                                    optionLabel="label"
                                    :placeholder="item.placeholder || TR.select"
                                    :filter="item.dropdown_items.length > 10 ? true : false"
                                    :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                    :showClear="item.showClear !== undefined && item.showClear == true ? true : false"
                                    :[item.attr]="item.attrValue"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    @input="PO['newdata'][item.name] = selectedItem[item.name]; (item.onInput !== undefined && typeof item.onInput === 'function' ? item.onInput($event, item) : null);"
                                    :optionGroupLabel="item.grouping !== undefined && item.grouping == true ? item.groupLabelField : ''"
                                    :optionGroupChildren="item.grouping !== undefined && item.grouping == true ? item.groupItemsField : ''"
                                >
                                    <template v-if="item.grouping !== undefined && item.grouping == true" #optiongroup="slotProps">
                                        <div v-html="(slotProps.option.icon ?? '') + (slotProps.option.icon ? ' ' : '' ) + slotProps.option.label"></div>
                                    </template>
                                    <template v-if="item.dropdown_icon" #dropdownicon>
                                        <i :class="item.dropdown_icon || 'fas fa-list'" />
                                    </template>
                                    <template v-if="item.dropdown_footer !== undefined && typeof item.dropdown_footer === 'function' ? item.dropdown_footer(item, $event) : (item.dropdown_footer !== undefined ? item.dropdown_footer : false)" #footer>
                                        <div class="p-2 d-flex justify-content-between border-top">
                                            <Button v-if="item.dropdown_add_btn !== undefined && typeof item.dropdown_add_btn === 'function' ? item.dropdown_add_btn() : (item.dropdown_add_btn !== undefined ? item.dropdown_add_btn : false)" :label="TR.add" severity="secondary" size="small" icon="fas fa-plus" variant="outlined" @click="item.dropdown_add_btn_callback !== undefined && typeof item.dropdown_add_btn_callback === 'function' ? item.dropdown_add_btn_callback() : null" />
                                        </div>
                                    </template>
                                </Select>

                                <MultiSelect
                                    v-else-if="item.field_type == 'multichip'"
                                    v-model="selectedItem[item.name]"
                                    :options="item.dropdown_items"
                                    :optionValue="item.option_value"
                                    :optionLabel="item.option_label"
                                    :filter="item.filter !== undefined && item.filter == true ? true : (item.dropdown_items.length > 10 ? true : false)"
                                    :placeholder="item.placeholder || TR.select"
                                    :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                    :maxSelectedLabels="item.maxSelectedLabels || 3"
                                    @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                    :selectedItemsLabel="item.selectedItemsLabel"
                                    display="chip"
                                >
                                    <!-- :pt="{
                                        labelContainer: {
                                            onChange: () => '{0} items secilib'
                                        }
                                    }" -->

                                    <template #option="slotProps">
                                        <div
                                            :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option[item.option_value || 'value']) : item.dropdown_item_class"
                                            v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option[item.option_label || 'label']"
                                        ></div>
                                    </template>

                                    <!-- <template #footer>
                                        <div class="py-2 px-3 border-top">
                                            <b>{{ selectedItem[item.name] ? selectedItem[item.name].length : 0 }}</b> {{ TR.selected }}
                                        </div>
                                    </template> -->

                                    <template v-if="item.dropdown_icon" #dropdownicon>
                                        <i :class="item.dropdown_icon || 'fas fa-list'" />
                                    </template>
                                    <template v-if="item.dropdown_footer !== undefined && typeof item.dropdown_footer === 'function' ? item.dropdown_footer(item, $event) : (item.dropdown_footer !== undefined ? item.dropdown_footer : false)" #footer>
                                        <div class="p-2 d-flex justify-content-between border-top">
                                            <Button v-if="item.dropdown_add_btn !== undefined && typeof item.dropdown_add_btn === 'function' ? item.dropdown_add_btn() : (item.dropdown_add_btn !== undefined ? item.dropdown_add_btn : false)" :label="TR.add" severity="secondary" size="small" icon="fas fa-plus" variant="outlined" @click="item.dropdown_add_btn_callback !== undefined && typeof item.dropdown_add_btn_callback === 'function' ? item.dropdown_add_btn_callback() : null" />
                                        </div>
                                    </template>

                                </MultiSelect>

                                <template v-else-if="item.field_type == 'multiselect'">
                                    <MultiSelect
                                        v-model="selectedItem[item.name]"
                                        :options="item.dropdown_items"
                                        optionValue="value"
                                        optionLabel="label"
                                        :filter="item.filter !== undefined && item.filter == true ? true : (item.dropdown_items.length > 10 ? true : false)"
                                        :placeholder="item.placeholder || TR.select"
                                        :class="( item.class || '' ) + (item.required !== undefined && item.required === true && (PO['newdata'][item.name] === undefined || PO['newdata'][item.name] === null || PO['newdata'][item.name] == 0) ? ' required' : '')"
                                        :maxSelectedLabels="1"
                                        @change="PO['newdata'][item.name] = selectedItem[item.name]; ( item.onChange !== undefined && typeof item.onChange === 'function' ) ? item.onChange($event, selectedItem, data, PO) : null;"
                                        :selectedItemsLabel="`{0} ${TR.group.toLowerCase()} ${TR.selected.toLowerCase()}`"
                                    >
                                        <!-- :pt="{
                                            labelContainer: {
                                                onChange: () => '{0} items secilib'
                                            }
                                        }" -->
                                        <!-- display="chip" -->

                                        <template #option="slotProps">
                                            <div
                                                :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                                v-html="(slotProps.option.icon ? `${slotProps.option.icon} ` : '' ) + slotProps.option.label"
                                            ></div>
                                        </template>

                                        <!-- <template #footer>
                                            <div class="py-2 px-3 border-top">
                                                <b>{{ selectedItem[item.name] ? selectedItem[item.name].length : 0 }}</b> {{ TR.selected }}
                                            </div>
                                        </template> -->

                                        <template v-if="item.dropdown_icon" #dropdownicon>
                                            <i :class="item.dropdown_icon || 'fas fa-list'" />
                                        </template>
                                        <template v-if="item.dropdown_footer !== undefined && typeof item.dropdown_footer === 'function' ? item.dropdown_footer(item, $event) : (item.dropdown_footer !== undefined ? item.dropdown_footer : false)" #footer>
                                            <div class="p-2 d-flex justify-content-between border-top">
                                                <Button v-if="item.dropdown_add_btn !== undefined && typeof item.dropdown_add_btn === 'function' ? item.dropdown_add_btn() : (item.dropdown_add_btn !== undefined ? item.dropdown_add_btn : false)" :label="TR.add" severity="secondary" size="small" icon="fas fa-plus" variant="outlined" @click="item.dropdown_add_btn_callback !== undefined && typeof item.dropdown_add_btn_callback === 'function' ? item.dropdown_add_btn_callback() : null" />
                                            </div>
                                        </template>

                                    </MultiSelect>

                                    <Listbox :options="selectedItem[item.name]" style="max-height: 100px; overflow: hidden; overflow-y: auto; width: 16rem;" class="bg-light">
                                        <template #option="slotProps">
                                            <div class="flex align-items-center">
                                                <div v-html="item.dropdown_items.filter(f => f.value == slotProps.option).length ? item.dropdown_items.filter(f => f.value == slotProps.option)[0].label : `<b class='text-danger fst-italic'>-- ID: (${slotProps.option}) ${TR.filter_disabled} --</b>` "></div>
                                            </div>
                                        </template>
                                    </Listbox>

                                </template>

                                <!-- <Teleport v-else-if="item.field_type == 'text_content'" to="body">
                                    <SecondModal :mainref="mainref" :show="showModal" :title="editor.title" :width="70" :toolbar="editor" :data="editor.data" @close="onModalClose" />
                                </Teleport> -->

                                <div v-else v-html="typeof item.value === 'function' ? item.value(data.data, data) : data.data[item.value]" :style="(typeof item.value === 'function' ? item.value(data.data, data) : data.data[item.value])?.length > 300 ? 'max-height: 300px; overflow-y: auto; border: 1px solid silver; padding: 8px; border-radius: 5px;' : ''"></div>

                                <!-- <template v-for="(btn, bindex) in item.buttons" :key="bindex">
                                        <button
                                            :class="`ms-2 me-sm-2 btn ${btn.class || 'btn-primary'}`"
                                            :title="btn.title !== undefined ? btn.title : ''"
                                            @click="$event.preventDefault(); showModal = true;"
                                        >
                                            <i :class="`me-1 ${btn.icon}`"></i>
                                            {{btn.label}}
                                        </button>{{btn}}
                                        <Teleport to="body">
                                            <SecondModal :show="showModal" :mainref="mainref" :data="btn" @close="showModal = false">
                                                <template #header>
                                                    custom header
                                                </template>
                                            </SecondModal>
                                        </Teleport> -->
                                    <!-- <button
                                        :class="`ms-2 me-sm-2 btn ${btn.class || 'btn-primary'}`"
                                        :title="btn.title !== undefined ? btn.title : ''"
                                        @click="btn.command(data, $event)"
                                    >
                                        <i :class="`me-1 ${btn.icon}`"></i>
                                        {{btn.label}}
                                    </button> -->
                                <!-- </template> -->




                            <!-- <div
                                v-if="item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)"
                                :class="item.class"
                            > -->
                            <!-- <div v-if="(item.private !== undefined && typeof item.private === 'function' ? item.private(data) === false ? true : false : (item.private === undefined || item.private === false ? true : false)) && item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)" :class="item.class"> -->

                                <template v-if="item.buttons !== undefined && item.field_type == 'element' && (data.data.editable === undefined || data.data.editable == true)">
                                <!-- <template v-if="item.buttons !== undefined && (data.data.editable === undefined || data.data.editable == true)"> -->
                                    <template v-for="(el, elind) in item.buttons" :key="elind">
                                        <div v-if="el.type == 'switch'" :class="el.class" class="form-check form-switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false">
                                            <input
                                                class="form-check-input"
                                                :class="el.class"
                                                @[el.event]="el.callback($event, item.data, PO)"
                                                type="checkbox"
                                                role="switch"
                                                :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false"
                                            />
                                        </div>
                                        <input
                                            v-else-if="el.type == 'checkbox'"
                                            class="form-check-input"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            type="checkbox"
                                            role="switch"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false"
                                        />
                                        <input
                                            v-else-if="el.type == 'text'"
                                            class="form-control"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            type="text"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false"
                                        />
                                        <button
                                            v-else-if="el.type == 'button' && (item.btn_visible && typeof item.btn_visible === 'function' ? item.btn_visible(item.data) : item.btn_visible !== undefined ? item.btn_visible : true)"
                                            :class="el.class"
                                            @[el.event]="el.callback($event, item.data, PO)"
                                            :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? item.disabled : item.disabled(data)) : false"
                                        >
                                            <i v-if="el.icon" :class="el.icon"></i>
                                            <span>{{el.text}}</span>
                                        </button>
                                    </template>
                                </template>
                            <!-- </div> -->
                            <!-- <div v-else="" v-html="(item.value && typeof item.value === 'function' ? item.value(data.data) : item.value !== undefined ? item.value : true)"></div> -->


                            </div>

                            <div class="col-12 col-sm-9" v-else-if="item.field_type != 'image' && item.field_type != 'file'">
                                <Image
                                    v-if="(item.name == 'preview_image' && item.field_type == 'label') || item.field_type == 'preview_image'"
                                    :src="PO['newdata'][item.name]"
                                    :alt="TR.image"
                                    height="90"
                                    :preview="false"
                                />
                                <span v-else v-html="typeof item.value === 'function' ? item.value(data.data, data) : data.data[item.value]"></span>
                            </div>

                            <div v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></div>
                            <!-- <td v-else v-html="typeof item.value === 'function' ? item.value(data.data) : data.data[item.value]"></td> -->

                        </div>
                    </template>

                </div>
            </div>

        <!-- </form> -->

    </div>

</template>


<script>
    import { ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";

    import { G } from "@/_common";

    import { useModelWrapper } from "@/system_modules/utils/modelWrapper";

    import Select from "primevue/select";
    import InputText from "primevue/inputtext";
    import Textarea from "primevue/textarea";
    import InputNumber from "primevue/inputnumber";
    import InputMask from "primevue/inputmask";
    import DatePicker from "primevue/datepicker";
    // import FileUpload from "primevue/fileupload";
    import Image from "primevue/image";
    import ColorPicker from 'primevue/colorpicker';
    import MultiSelect from 'primevue/multiselect';
    import Listbox from 'primevue/listbox';
    import Tabs from 'primevue/tabs';
    import TabList from 'primevue/tablist';
    import Tab from 'primevue/tab';
    import TabPanels from 'primevue/tabpanels';
    import TabPanel from 'primevue/tabpanel';
    import Button from 'primevue/button';
    // import Badge from 'primevue/badge';

    // import Editor from 'primevue/editor';
    import TextEditor from '@/components/field/TextEditor';
    import TextEditor2 from '@/components/field/TextEditor2';

    import InputFile from "@/components/field/InputFile";


    export default {
        name: 'DynamicTable2',
        props: {
            data: {
                type: Object,
                default(){
                    return null;
                }
            },
            mainref: {
                type: Object,
                default(){
                    return null;
                }
            },
        },
        components: {
            // SecondModal,
            Select,
            InputText,
            Textarea,
            InputNumber,
            InputMask,
            DatePicker,
            // FileUpload,
            InputFile,
            Image,
            ColorPicker,
            MultiSelect,
            Listbox,
            Tabs,
            TabList,
            Tab,
            TabPanels,
            TabPanel,
            Button,
            // Badge,
            TextEditor,
            TextEditor2,
        },
        setup(props, { emit }) {
            const store = useStore();

            const TR = ref({});
            const PO = useModelWrapper(props, emit, "mainref");
            const selectedItem = ref({});
            PO.value['newdata'] = {};

            const showModal = ref(false);
            // const editor = ref({data: {editorData: ''}});

            const onFileChanged = (e, field_name) => {
                if (e.files) {
                    totalSize.value = 0;
                    Array.from(e.files).forEach((file) => {
                        totalSize.value += file.size;
                    });

                    let a = false;
                    if( props.data.table_columns ){
                        props.data.table_columns.forEach((item) => {
                            if(item.name == field_name && item.fileMultiple){
                                a = true;
                                PO.value['newdata'][field_name] = e.files;
                            }
                            else if( item.name == field_name ){
                                a = true;
                                PO.value['newdata'][field_name] = e.files[0];
                            }
                        });
                    }
                    if(!a){
                        PO.value['newdata'][field_name] = e.files[0];
                    }
                    PO.value['newdata']["preview_image"] = URL.createObjectURL(e.files[0]); //.objectURL;
                    // props.data['preview_image'] = e.files[0].objectURL;
                }
            };

            const onImageChanged = (event) => {
                PO.value["preview_image"] = event.target.value;
            };

            watchEffect(() => {
                TR.value = store.getTranslation();
                // props.data.table_columns.forEach((item) => {
                    // if( item.name == 'preview_image' && typeof item.field_type !== undefined && item.field_type == 'label' ){
                    //     PO.value[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    //     // props.data.data[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    // }
                    // if( typeof item.field_type !== undefined && item.field_type != 'label' ){
                    //     PO.value[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                    // }
                    // if( item.dropdown_item_selected !== undefined )
                    //     selectedItem.value[item.name] = item.dropdown_item_selected;
                // });
            // });

            // onMounted(() => {
                if( props.data.table_columns_forlang ){
                    props.data.table_columns_forlang.forEach((item) => {
                        if ( typeof item.field_type !== undefined && item.field_type != "label" ) {
                            G.lang_list.forEach((a) => {
                                if( PO.value['newdata'][item.name] === undefined ){
                                    PO.value['newdata'][item.name] = {};
                                }
                                let ldata = props.data.data.translate ? props.data.data.translate.filter( b => b.lang_id == a.value) : [];
                                PO.value['newdata'][item.name][a.value] =
                                    typeof item.value === "function"
                                        ? item.value(ldata.length ? ldata[0] : {[item.name]: props.data.data[item.alternative_name_field]})
                                        : props.data.data[item.value];
                            });
                        }
                    });
                }
                if( props.data.table_columns ){
                    props.data.table_columns.forEach((item) => {
                        if (
                            item.name == "preview_image" &&
                            typeof item.field_type !== undefined &&
                            item.field_type == "label"
                        ) {
                            PO.value['newdata'][item.name] =
                                typeof item.value === "function"
                                    ? item.value(props.data.data, props.data)
                                    : props.data.data[item.value];
                            // props.data.data[item.name] = (typeof item.value === 'function' ? item.value(props.data.data) : props.data.data[item.value]);
                        }
                        if (
                            typeof item.field_type !== undefined &&
                            item.field_type != "label"
                        ) {
                            PO.value['newdata'][item.name] =
                                typeof item.value === "function"
                                    ? item.value(props.data.data, props.data)
                                    : props.data.data[item.value];
                        }

                        if (item.dropdown_item_selected !== undefined){
                            selectedItem.value[item.name] = ( typeof item.field_type !== undefined && item.field_type == "multiselect" ) ? [...item.dropdown_item_selected] : item.dropdown_item_selected;
                            PO.value['newdata'][item.name] = item.dropdown_item_selected;
                        }
                        if (item.selectbox_item_selected !== undefined){
                            selectedItem.value[item.name] = ( typeof item.field_type !== undefined && item.field_type == "multiselect" ) ? [...item.selectbox_item_selected] : item.selectbox_item_selected;
                            PO.value['newdata'][item.name] = item.selectbox_item_selected;
                        }
                        if ((props.data.data[item.value] === undefined || props.data.data[item.value] == null || props.data.data[item.value] == '') && item.default !== undefined){
                            selectedItem.value[item.name] = ( typeof item.field_type !== undefined && item.field_type == "multiselect" ) ? [...item.selectbox_item_selected] : item.default;
                            PO.value['newdata'][item.name] = item.default;
                        }
                    });
                }
            });


            const totalSize = ref(0);
            // const totalSizePercent = ref(0);
            const files = ref([]);

            const onRemoveTemplatingFile = (file, removeFileCallback, index) => {
                removeFileCallback(index);
                totalSize.value -= file.size;
                // totalSizePercent.value = totalSize.value / 10;
            };

            const onClearTemplatingUpload = (clear) => {
                clear();
                totalSize.value = 0;
                // totalSizePercent.value = 0;
            };

            const onSelectedFiles = (event) => {
                files.value = event.files;
                files.value.forEach((file) => {
                    totalSize.value += file.size;
                });
            };

            const uploadEvent = (callback) => {
                // totalSizePercent.value = totalSize.value / 10;
                callback();
            };

            const onTemplatedUpload = () => {
                // toast.add({ severity: "info", summary: "Success", detail: "File Uploaded", life: 3000 });
            };

            const clearFiles = (clearCallback) => {
                totalSize.value = 0;
                files.value = [];
                clearCallback();
            };

            return {
                G,
                TR,
                store,
                PO,
                selectedItem,
                onFileChanged,
                onImageChanged,
                showModal,

                // editor,

                onTemplatedUpload,
                uploadEvent,
                onSelectedFiles,
                onClearTemplatingUpload,
                onRemoveTemplatingFile,
                totalSize,
                // totalSizePercent,
                files,
                clearFiles,
            };
        },
    };
</script>


<style lang="scss" scoped>
.dynamic-table{
    .modal-backdrop{
        z-index: 9;
    }
    .table {
        width: 100%;
        margin-bottom: 1rem;
        // color: #7b809a;
        vertical-align: top;
        border-color: #f0f2f5;
    }
    .table thead th {
        // padding: .75rem 1.5rem;
        letter-spacing: 0;
        // border-bottom: 1px solid #f0f2f5;
        // border-bottom-color: rgb(240, 242, 245);
        text-transform: uppercase !important;
        color: var(--bs-secondary);
    }
    /*.table > :not(:first-child) {
        border-top: 1px solid currentColor;
    }*/
    .table.align-items-center td,
    .table.align-items-center th {
        vertical-align: middle;
    }
    .p-dropdown, .p-select, .p-multiselect {
        width: 16rem;
    }
    .required{
        border: 1px solid #ff0000;
        border-radius: 5px;
    }
    .p-image-toolbar{
        z-index: 9999;
        background: rgba(190, 190, 190, 0.5);
    }
    .p-image-preview{
        background-color: #fff;
        height: 90%;
    }
    .p-multiselect .p-highlight {
        background: transparent !important;
    }
    textarea::placeholder{
        color: rgba(var(--bs-secondary-rgb), .5) !important;
    }
}
</style>

